import React from 'react'

export const InstagramIcon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg'
    style={props.style}
    className={`icon--social icon--social-instagram ${props.className || ''}`}
    viewBox='0 0 32 32'
  >
    <path
      d='M26.02,29.34H5.982c-1.659,0-3.005-1.346-3.005-3.006V6.299 c0-1.66,1.346-3.005,3.005-3.005H26.02c1.66,0,3.004,1.345,3.004,3.005v20.035C29.023,27.994,27.68,29.34,26.02,29.34L26.02,29.34 L26.02,29.34z M16.001,11.309c-2.767,0-5.01,2.242-5.01,5.008c0,2.765,2.243,5.009,5.01,5.009c2.766,0,5.01-2.244,5.01-5.009 C21.012,13.551,18.768,11.309,16.001,11.309L16.001,11.309L16.001,11.309z M26.02,7.301c0-0.554-0.447-1.002-1.002-1.002h-3.006 c-0.553,0-1,0.448-1,1.002v3.006c0,0.553,0.447,1.002,1,1.002h3.006c0.555,0,1.002-0.449,1.002-1.002V7.301L26.02,7.301z M26.02,14.314h-2.268c0.166,0.641,0.262,1.312,0.262,2.003c0,4.425-3.586,8.013-8.012,8.013c-4.427,0-8.015-3.588-8.015-8.013 c0-0.691,0.098-1.362,0.263-2.003H5.982v11.018c0,0.555,0.448,1.002,1.002,1.002h18.033c0.555,0,1.002-0.447,1.002-1.002V14.314 L26.02,14.314z'
    />
  </svg>
)
